<template>
  <v-container id="attendance-list">
    <v-btn
      type="button"
      color="primary"
      text
      style="margin-left: 10px"
      @click="goBack()"
    >
      Voltar
    </v-btn>
    <v-card v-for="tab in tabs" :key="tab.id" class="rounded-0 bg-light inside">
      <div v-if="tabName === tab.id" class="mb-6">
        <component
          v-bind:is="dinamicyComponent(tab.component)"
          :mostrarIniciativas="tab.mostrarIniciativas"
        ></component>
      </div>
    </v-card>
  </v-container>
</template>
<script>
const tabsComponent = {
  Territorios: () => import("./territorios/Insert"),
  Categorias: () => import("./categorias/Insert"),
  Iniciativas: () => import("./territorios/Insert"),
  Responsaveis: () => import("./responsaveis/Insert"),
};

export default {
  data() {
    return {
      tabs: [
        { id: "territorios", name: "Territorios", component: "Territorios" },
        // { id: "vocacao", name: "Vocações", component: "Vocacao" },
        // { id: "potenciais", name: "Potenciais", component: "Potenciais" },
        {
          id: "categorias",
          name: "Categorias",
          component: "Categorias",
        },
        {
          id: "iniciativas",
          name: "Iniciativas",
          component: "Iniciativas",
          mostrarIniciativas: true,
        },
        { id: "responsaveis", name: "Responsáveis", component: "Responsaveis" },
      ],
      tabName: this.$route.params.tab,
    };
  },

  methods: {
    dinamicyComponent(tab) {
      return tabsComponent[tab];
    },
    goBack() {
      this.$router.push(`/gestao-territorios/${this.$route.params.tab}`);
    },
  },
};
</script>
